import axios from 'axios';

export const BACKEND_BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
const API_BASE = `${BACKEND_BASE_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add auth interceptor
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Обработка протухшего/неверного токена: чистим его и отправляем админа на
// повторный вход, вместо того чтобы оставлять на висящей плашке «Токен истёк».
// Срабатывает только когда токен реально был и упавший запрос — не сам логин
// (логин/регистрация показывают свою ошибку через форму).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || '';
    const isAuthCall = url.includes('/admin/login') || url.includes('/admin/register');
    const hadToken = !!localStorage.getItem('admin_token');
    if (status === 401 && hadToken && !isAuthCall) {
      localStorage.removeItem('admin_token');
      if (!window.location.pathname.startsWith('/admin/login')) {
        window.location.assign('/admin/login?expired=1');
      }
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) => 
  api.post('/admin/login', { username, password });

export const register = (username, password) => 
  api.post('/admin/register', { username, password });

export const getAdminProfile = () => 
  api.get('/admin/me');

// Categories
// Public callers (DesignerPage, Sidebar) pass `variant` so the backend filters
// the catalog by blagoustroistvo / pamyatniki. Admin omits it to see everything.
export const getCategories = (variant) =>
  api.get('/categories', { params: variant ? { variant } : {} });

export const createCategory = (data) => 
  api.post('/categories', data);

export const updateCategory = (id, data) => 
  api.put(`/categories/${id}`, data);

export const deleteCategory = (id) => 
  api.delete(`/categories/${id}`);

// Stones (справочник камней, ₸/м³)
export const getStones = (activeOnly = false) =>
  api.get('/stones', { params: activeOnly ? { active_only: true } : {} });
export const ensureDefaultStones = () => api.post('/stones/ensure-defaults');
export const createStone = (data) => api.post('/stones', data);
export const updateStone = (id, data) => api.put(`/stones/${id}`, data);
export const deleteStone = (id) => api.delete(`/stones/${id}`);

// Elements
// `variant` works the same way as in getCategories — public callers pass it,
// admin omits it.
export const getElements = (categoryId, includeInactive = false, variant) =>
  api.get('/elements', {
    params: {
      ...(categoryId ? { category_id: categoryId } : {}),
      ...(includeInactive ? { include_inactive: true } : {}),
      ...(variant ? { variant } : {}),
    }
  });

export const getElement = (id) => 
  api.get(`/elements/${id}`);

export const createElement = (data) => 
  api.post('/elements', data);

export const updateElement = (id, data) => 
  api.put(`/elements/${id}`, data);

export const deleteElement = (id) => 
  api.delete(`/elements/${id}`);

// Model Types
export const getModelTypes = () => 
  api.get('/model-types');

export const updateModelType = (key, data) => 
  api.put(`/model-types/${key}`, data);

// Seed
export const seedData = () => 
  api.post('/seed');

// Export
export const exportProject = (data) => 
  api.post('/export', data);

// Shared Projects
export const shareProject = (data) => 
  api.post('/share', data);

export const getSharedProject = (projectId) => 
  api.get(`/share/${projectId}`);

// File uploads
export const uploadModel = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/model', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const uploadTexture = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/texture', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export const uploadCategoryIcon = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/upload/icon', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
};

export default api;
